export const LOAD_USER_LIST_REQUEST = 'LOAD_USER_LIST_REQUEST';
export const LOAD_USER_LIST_SUCCESS = 'LOAD_USER_LIST_SUCCESS';
export const LOAD_USER_LIST_FAILURE = 'LOAD_USER_LIST_FAILURE';

export const LOAD_PRICES_LAST_REFRESH_DATE_FAILURE = 'LOAD_PRICES_LAST_REFRESH_DATE_FAILURE';
export const LOAD_PRICES_LAST_REFRESH_DATE_SUCCESS = 'LOAD_PRICES_LAST_REFRESH_DATE_SUCCESS';
export const LOAD_PRICES_LAST_REFRESH_DATE_REQUEST = 'LOAD_PRICES_LAST_REFRESH_DATE_REQUEST';

